import { CUSTOMER_ORDER_ACTIVE_STATUS_VALUES } from '../../../types/order';

// UX mirror of backend customerOrderStatusPolicy.participatesInStockAllocation.
export function canCreateSupplierDrafts(order: { status: string; isQuote?: boolean; archivedAt?: string | null }): boolean {
  return !order.isQuote && !order.archivedAt
    && (CUSTOMER_ORDER_ACTIVE_STATUS_VALUES as readonly string[]).includes(order.status)
    && !['NEW_INQUIRY', 'QUOTE_SENT', 'CANCELLED', 'INVOICED'].includes(order.status);
}
